import { Navigate } from 'react-router-dom';
import authService from './services/auth.service';

export default function UserRoute({ children }) {
  if (authService.isAdmin()) return <Navigate to="/admin/dashboard" replace />;
  return children;
}
